import React, { useState } from 'react';
import { useCtx, useRecurso, useAccion, api } from '../estado.jsx';
import { Recurso, SedeTabs } from './Comunes.jsx';
import { formatearTel } from '../utiles/telefono.js';

export function ClientesView() {
  const { sedeId, openModal } = useCtx();
  const clientes = useRecurso(() => api.clientes(), []);
  const sede = useRecurso(() => api.sede(sedeId), [sedeId]);
  const { ejecutar, enCurso, error, setError } = useAccion();

  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [email, setEmail] = useState('');

  const añadir = () => {
    if (!nombre.trim() || !telefono.trim()) {
      setError('Nombre y teléfono son obligatorios.');
      return;
    }
    // El duplicado ya no se comprueba aquí: lo garantiza UNIQUE(sede_id,
    // telefono) en la base. Comprobarlo en el frontend dejaría pasar dos
    // altas simultáneas, y además obligaría a tener la lista completa cargada.
    ejecutar(
      () => api.crearCliente({ nombre: nombre.trim(), telefono: telefono.trim(), email: email.trim() || undefined }),
      () => { setNombre(''); setTelefono(''); setEmail(''); },
    );
  };

  return (
    <div className="view on">
      <SedeTabs id={sedeId} active="clientes" />
      <div className="h-eyebrow">{sede.datos ? sede.datos.comuna : ''} · Clientes</div>
      <h1 className="h-title">Clientes de <em>{sede.datos ? sede.datos.comuna : '…'}</em></h1>
      <p className="h-sub">
        Se dan de alta una sola vez. Si el cliente ya reservó por su cuenta, aquí aparece;
        si es su primera vez, lo registras tú.
      </p>

      <h2 className="section-h">Añadir cliente</h2>
      <div className="oferta-form bono-form">
        <div className="field" style={{ margin: 0 }}><label>Nombre</label>
          <input className="inp" value={nombre} onChange={(e) => setNombre(e.target.value)}
                 placeholder="Nombre y apellidos" /></div>
        <div className="field" style={{ margin: 0 }}><label>Teléfono</label>
          <input className="inp" type="tel" value={telefono} onChange={(e) => setTelefono(e.target.value)}
                 placeholder="+56 9 ..." /></div>
        <div className="field" style={{ margin: 0 }}><label>Email</label>
          <input className="inp" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                 placeholder="correo@mail.com" /></div>
        <button className="btn" onClick={añadir} disabled={enCurso}>
          {enCurso ? 'Añadiendo…' : 'Añadir'}
        </button>
      </div>
      <div className="inline-err show">{error}</div>

      <h2 className="section-h">Fichas</h2>
      <Recurso estado={clientes} que="los clientes">
        {(lista) => lista.length === 0
          ? <div className="empty-line">Aún no hay clientes en esta sede.</div>
          : (
            <div className="cli-grid">
              {lista.map((c) => (
                <div key={c.id} className="cli-card">
                  <div className="cc-top">
                    <div className="cc-name">{c.nombre}</div>
                    <div className="cc-visits">{c.visitas === 0 ? 'sin visitas' : c.visitas + (c.visitas === 1 ? ' visita' : ' visitas')}</div>
                  </div>
                  <div className="cc-row"><span className="cc-k">Teléfono</span><span className="cc-v">{formatearTel(c.telefono)}</span></div>
                  {c.email ? <div className="cc-row"><span className="cc-k">Email</span><span className="cc-v">{c.email}</span></div> : null}
                  {c.tune_id ? <div className="cc-row"><span className="cc-k">ID TUNE</span><span className="cc-v">{c.tune_id}</span></div> : null}
                  {c.bonos && c.bonos.length ? (
                    <div className="cc-bonos">
                      {c.bonos.map((b) => (
                        <div key={b.id} className="cc-bono">
                          <span>{b.nombre}</span>
                          <span className="cc-saldo">{b.restantes}/{b.totales}</span>
                        </div>
                      ))}
                    </div>
                  ) : null}
                  <div className="cc-actions">
                    <button className="tlink" onClick={() => openModal({ tipo: 'editarCliente', cliente: c })}>Editar</button>
                    <button className="tlink" onClick={() => openModal({ tipo: 'venderBono', cliente: c })}>Vender bono</button>
                  </div>
                </div>
              ))}
            </div>
          )}
      </Recurso>
    </div>
  );
}
